import { ComponentProps, ReactNode } from "react";
import { cn } from "../../../lib/utils";
import { InputLabel } from "./input-label";

export type TAppInputProps = ComponentProps<"input"> & {
  inputError?: string;
  containerClassName?: string;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  label?: string;
  fullWidth?: boolean;
  isOptional?: boolean;
};

export function AppInput(props: TAppInputProps) {
  const {
    className,
    type,
    inputError,
    containerClassName,
    label,
    startAdornment,
    endAdornment,
    fullWidth,
    isOptional,
    ...otherProps
  } = props;
  return (
    <label
      className={cn(
        "relative flex flex-col gap-[1px]",
        fullWidth && "w-full",
        otherProps.disabled && "pointer-events-none cursor-not-allowed opacity-50",
        containerClassName
      )}
      data-slot="input-wrapper"
    >
      {startAdornment && (
        <span className="absolute left-3 bottom-2 text-innoveraZinc-400 w-4 h-4 [&>svg]:w-4 [&>svg]:h-4">
          {startAdornment}
        </span>
      )}
      {endAdornment && (
        <span className="absolute right-3 bottom-2 text-innoveraZinc-400 w-4 h-4 [&>svg]:w-4 [&>svg]:h-4">
          {endAdornment}
        </span>
      )}
      {label && (
        <InputLabel isOptional={isOptional} className="mb-2">
          {label}
        </InputLabel>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "border border-innoveraZinc-150 placeholder:text-innoveraZinc-400 text-innoveraZinc-900 h-[32px] min-w-0 rounded-[8px] bg-transparent text-[16px] laptop:text-[13px] transition-shadow duration-200 ease-in-out outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
          startAdornment ? "pl-8 pr-3" : "px-3",
          endAdornment ? "pr-8" : "pr-3",
          "hover:ring-2 hover:ring-innoveraZinc-150 focus-visible:ring-2 focus-visible:ring-innoveraZinc-150",
          !!inputError && "border-innoveraRed-400 hover:ring-innoveraRed-50 focus-visible:ring-innoveraRed-50",
          fullWidth && "w-full",
          className
        )}
        {...otherProps}
      />
      {inputError && <p className="absolute bottom-[-14px] left-1 text-innoveraRed-400 text-[10px]">{inputError}</p>}
    </label>
  );
}
